import { memo } from 'react';

type GooglePayLogoPlainProps = {
  width?: number;
  height?: number;
};

const GooglePayLogoPlain = ({
  width = 24,
  height = 14,
}: GooglePayLogoPlainProps) => {
  return (
    <svg
      width={width.toString()}
      height={height.toString()}
      viewBox="0 0 24 14.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4803 7.11089V9.39251H10.7713V3.75792H12.6517C12.8761 3.75314 13.0993 3.79378 13.3083 3.8775C13.5172 3.96122 13.7079 4.08637 13.8693 4.24572C14.0323 4.39539 14.162 4.57895 14.2497 4.78406C14.3375 4.98917 14.3812 5.21107 14.3779 5.43486C14.3826 5.65984 14.3395 5.88319 14.2518 6.08961C14.164 6.29602 14.0335 6.48062 13.8693 6.63074C13.5405 6.95084 13.1346 7.11074 12.6517 7.11044L11.4803 7.11089ZM11.4803 4.45163V6.41854H12.6693C12.7996 6.42248 12.9293 6.39861 13.0501 6.34844C13.1709 6.29828 13.2802 6.22293 13.3708 6.12721C13.5497 5.94967 13.6521 5.70686 13.6556 5.4522C13.6591 5.19754 13.5634 4.95188 13.3895 4.76927C13.3834 4.76281 13.3771 4.75643 13.3708 4.75015C13.2813 4.65241 13.1725 4.57521 13.0515 4.52367C12.9306 4.47213 12.8003 4.44742 12.6693 4.45118L11.4803 4.45163Z"
        fill="#5F6368"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0117 5.41143C16.5357 5.41143 16.9494 5.55439 17.2527 5.84033C17.5559 6.12626 17.7074 6.51829 17.7071 7.01643V9.39245H17.029V8.85745H16.9981C16.7045 9.29804 16.3141 9.51834 15.8267 9.51834C15.4107 9.51834 15.0627 9.39245 14.7826 9.14069C14.6482 9.02514 14.5408 8.88042 14.4681 8.71709C14.3954 8.55376 14.3593 8.37594 14.3625 8.19657C14.3625 7.79765 14.5102 7.48039 14.8055 7.24481C15.1009 7.00923 15.4951 6.89114 15.9884 6.89054C16.4094 6.89054 16.7561 6.96922 17.0285 7.12657V6.96113C17.0293 6.83885 17.0035 6.71792 16.9528 6.60711C16.9022 6.4963 16.828 6.39839 16.7357 6.32048C16.5482 6.14778 16.3038 6.05356 16.0513 6.05657C15.6553 6.05657 15.3419 6.22712 15.1111 6.5682L14.4867 6.16672C14.8302 5.66319 15.3385 5.41143 16.0117 5.41143ZM15.0944 8.21231C15.0939 8.30443 15.115 8.39533 15.1559 8.47744C15.1968 8.55955 15.2564 8.6305 15.3296 8.68437C15.4864 8.81029 15.681 8.877 15.8805 8.87319C16.1797 8.87268 16.4664 8.75111 16.678 8.53511C16.9128 8.30942 17.0303 8.04462 17.0303 7.7407C16.8092 7.56087 16.501 7.47095 16.1055 7.47095C15.8175 7.47095 15.5773 7.54184 15.3851 7.6836C15.1908 7.82747 15.0944 8.00235 15.0944 8.21231Z"
        fill="#5F6368"
      />
      <path
        d="M19.2326 11.0919L21.6 5.53733H20.828L19.7337 8.30674H19.7183L18.5931 5.53733H17.8225L19.3792 9.14835L18.5007 11.0919H19.2326Z"
        fill="#5F6368"
      />
      <path
        d="M8.61524 6.61907C8.6155 6.39849 8.59723 6.17829 8.56063 5.96089H5.57052V7.20757H7.28312C7.24807 7.40669 7.1739 7.59649 7.06506 7.76555C6.95623 7.93461 6.81499 8.07942 6.64986 8.19125V9.0005H7.67196C8.27043 8.43717 8.61524 7.6041 8.61524 6.61907Z"
        fill="#4285F4"
      />
      <path
        d="M5.57051 9.78237C6.42615 9.78237 7.1466 9.49554 7.67196 9.001L6.64986 8.19176C6.36538 8.38868 5.99899 8.50107 5.57051 8.50107C4.7435 8.50107 4.04155 7.9319 3.79054 7.16492H2.73761V7.99889C3.00151 8.535 3.40617 8.98569 3.90641 9.30062C4.40666 9.61555 4.9828 9.78234 5.57051 9.78237Z"
        fill="#34A853"
      />
      <path
        d="M3.79054 7.16492C3.65784 6.76302 3.65784 6.32778 3.79054 5.92588V5.09191H2.73762C2.51562 5.54291 2.4 6.04066 2.4 6.5454C2.4 7.05014 2.51562 7.54789 2.73762 7.99889L3.79054 7.16492Z"
        fill="#FBBC04"
      />
      <path
        d="M5.57051 4.58965C6.02268 4.5821 6.45959 4.75652 6.78681 5.07519L7.69177 4.15131C7.11793 3.60105 6.35772 3.29896 5.57051 3.30834C4.9828 3.30837 4.40666 3.47516 3.90641 3.7901C3.40617 4.10503 3.00151 4.55571 2.73761 5.09183L3.79053 5.9258C4.04155 5.15881 4.7435 4.58965 5.57051 4.58965Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export const GooglePayLogoPlainIllustration = memo(GooglePayLogoPlain);
